import {
  getServiceInfo,
  getBasicInfo,
  getConsultService,
  getDynamicList,
  businesses,
  getRateList,
  getUserRelation,
  talkVideos,
  getQingsuService,
  getQingsuRateList,
  getQingsuNewVisit
} from 'api/platform/homepage.js'
import { isObject, isDef } from 'utils/tool.js'

const store = {
  namespaced: true,
  state: () => ({
    distance: {
      statusbarHeight: 0, // App内状态栏高度
      headerHeight: 0, // 最顶部header栏高度
      navHeight: 0, // 全局tab栏的高度
      zxNavHeight: 0 // 咨询tab栏的高度
    },

    basicInfo: {}, // 个人主页基础信息
    serviceInfo: [], // 服务信息（全局，跟访客登录无关）
    zxAdvancedInfo: {}, // 服务信息（咨询独有，比如优惠券、活动、套餐、预咨询等，跟访客登录相关）
    userRelation: {}, // 用户关系（是否关注/拉黑等）

    currentTab: {},
    basicInfoDisabled: false, // 用户是否被禁

    dynamicList: [], // 动态列表
    qaList: [], // 问答列表
    fmList: [], // 商家列表
    articleList: [], // 文章列表
    storyList: [], // 故事列表
    RateList: [], // 评价列表
    serviceTabRateList: [], // 服务tab的评价列表
    rateCount: 0, // 评价总数
    cerrentRateType: 1, // 当前评价类型
    rateListFinish: false, // 评价是否已到最后
    isRateTab: false, // 是否展示评价tab
    talkVideoInfo: null, // 老师相册，视频
    qingsuService: {}, // 倾听服务
    commonRateType: 'consult', // 评价类型：咨询/倾诉
    //倾诉评价相关
    qingsuRateInfo: {
      list: [],
      isFinish: false
    },
    qingsuVisit: {}, // 倾诉来访相关
    qingsuType: 'voice' // 倾诉类型：语音/文字
  }),
  getters: {
    rateFinish(state) {
      return state.rateListFinish
    },
    parsedLevel(state) {
      let { level } = state.basicInfo
      if (!isObject(level)) {
        level = {}
      }
      return isDef(level.level_name) ? level : null
    },
    firstIdentity(state) {
      let { identities } = state.basicInfo
      identities = Array.isArray(identities) ? identities : []
      return identities.length ? identities[0] : null
    },
    // 咨询服务信息
    consultServiceInfo(state) {
      const target = state.serviceInfo.find(
        item => item.service && item.service.service_role === 'teacher'
      )
      return target ? target.content : {}
    },
    // 心探服务信息
    phychicServiceInfo(state) {
      const target = state.serviceInfo.find(
        item => item.service && item.service.service_role === 'psychic_coach'
      )
      return target ? target.content : {}
    },
    // 访谈
    interviewList(state, getters) {
      const { qa = [] } = getters.consultServiceInfo
      return qa
    },
    // 有没有服务
    hasService(state) {
      const { serviceInfo = [] } = state
      return serviceInfo.length
    },

    roles(state) {
      const { roles } = state.basicInfo
      return Array.isArray(roles) ? roles : []
    },
    // 当前url访问的 是否咨询师
    isConsultTeacher(state, getters) {
      return getters.roles.includes('teacher')
    },
    // 当前url访问的 是否倾听师
    isQingtingTeacher(state, getters) {
      return getters.roles.includes('qingting')
    },
    // 当前url访问的 是否心探教练
    isPsychicCoach(state, getters) {
      return getters.roles.includes('psychic_coach')
    },
    //  当前url访问的 是否普通用户
    isNormalUser(state, getters) {
      return getters.roles.length === 0
    },

    // 计算第一层tab的吸顶距离
    stickOffsetTop(state) {
      return state.distance.headerHeight
    },
    // 计算第二层tab的吸顶距离
    zxStickOffsetTop(state) {
      return state.distance.headerHeight + state.distance.navHeight - 2
    },
    // 获取动态列表
    getDynamicListData(state) {
      return state.dynamicList
    },
    getTabListData: state => type => {
      if (type === 'qa') {
        return state.qaList
      } else if (type === 'fm') {
        return state.fmList
      } else if (type === 'article') {
        return state.articleList
      } else if (type === 'story') {
        return state.storyList
      }
      return []
    },
    // 获取评价列表
    getRateListData(state) {
      return state.RateList
    },
    // 获取当前评价类型
    getCurrentRateType(state) {
      return state.cerrentRateType
    },
    // 获取评价总数
    getRateCount(state) {
      return state.rateCount
    },
    // 获取tab评价上显示数量
    getTabRateNum(state) {
      const { basicInfo, commonRateType } = state
      const { rate_num, qing_info = {} } = basicInfo
      if (commonRateType === 'consult' && rate_num) {
        return rate_num
      }
      return qing_info.ratenum || 0
    }
  },
  mutations: {
    SET_CURRENT_TAB(state, tab) {
      state.currentTab = tab || {}
    },
    SET_DISTANCE(state, distance) {
      state.distance = {
        ...state.distance,
        ...distance
      }
    },
    SET_BASIC_INFO(state, obj) {
      state.basicInfo = obj || {}
    },
    SET_BASIC_INFO_DISABLED(state, payload) {
      state.basicInfoDisabled = payload
    },
    SET_CONSULT_SERVICE(state, obj) {
      state.zxAdvancedInfo = obj || {}
    },
    SET_USER_RELATION(state, obj) {
      state.userRelation = obj || {}
    },
    SET_SERVICE_INFO(state, arr) {
      state.serviceInfo = arr || []
    },
    SET_DYNAMIC_LIST(state, data) {
      state.dynamicList = data.isFrist
        ? data.list
        : [...state.dynamicList, ...data.list]
    },
    SET_BUSINESSES_LIST(state, data) {
      if (data.type == 'qa') {
        state.qaList = data.isFrist
          ? data.list
          : [...state.qaList, ...data.list]
      } else if (data.type == 'fm') {
        state.fmList = data.isFrist
          ? data.list
          : [...state.fmList, ...data.list]
      } else if (data.type == 'article') {
        state.articleList = data.isFrist
          ? data.list
          : [...state.articleList, ...data.list]
      } else if (data.type == 'story') {
        state.storyList = data.isFrist
          ? data.list
          : [...state.storyList, ...data.list]
      }
    },
    SET_RATE_LIST(state, data) {
      state.RateList = data.isFrist
        ? data.list
        : [...state.RateList, ...data.list]
      state.rateListFinish = data.isFinished
      state.isRateTab = data.isRateTab
    },
    SET_SERVICE_TAB_RATE_LIST(state, data) {
      state.serviceTabRateList = data
    },
    SET_RATE_COUNT(state, data) {
      state.rateCount = data
    },
    // 更新某个评论
    UPDATE_RATE(state, target) {
      const keyList = ['RateList', 'serviceTabRateList']
      keyList.forEach(key => {
        const list = state[key]
        const index = list.findIndex(item => +item.id === +target.id)
        if (index > -1) {
          list.splice(index, 1, {
            ...list[index],
            ...target
          })
        }
      })
    },
    SET_CURRENT_RATE_TYPE(state, type) {
      state.cerrentRateType = type
    },
    RESET_IS_RATE_TAB(state) {
      state.isRateTab = false
    },
    SETTALKVIDEO(state, videos) {
      state.talkVideoInfo = videos
    },
    // 设置评价类型：咨询/倾诉
    SET_COMMON_RATE_TYPE(state, type) {
      state.commonRateType = type
    },
    //设置倾诉相关信息
    SET_QINGSU_SERVICE(state, info) {
      state.qingsuService = info
    },
    //设置倾诉评论相关
    SET_QINGSU_RATE_INFO(state, data) {
      const { list } = state.qingsuRateInfo
      state.qingsuRateInfo.list = data.isFrist
        ? data.list
        : [...list, ...(data.list || [])]
      state.qingsuRateInfo.isFinish = data.isFinish
      state.isRateTab = data.isRateTab
    },
    SET_QINGSU_VISIT(state, data) {
      state.qingsuVisit = data
    },
    SET_QINGSU_TYPE(state, type) {
      state.qingsuType = type
    }
  },
  actions: {
    fetchBasicInfo({ commit }, params) {
      return getBasicInfo(params)
        .then(res => {
          const { code, data } = res
          if (data && data.avatar) {
            data.avatar = data.avatar.replace(/\?x-oss-process=(.*)$/g, '')
          }
          commit('SET_BASIC_INFO', code === 0 ? data : {})
          // 判断用户是否被禁
          commit('SET_BASIC_INFO_DISABLED', code === 40013)
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchServiceInfo({ commit }, params) {
      return getServiceInfo(params)
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            commit('SET_SERVICE_INFO', data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchConsultService({ commit }, params) {
      params = { ...params, v: 2 }
      return getConsultService(params)
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            commit('SET_CONSULT_SERVICE', data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchUserRelation({ commit }, params) {
      return getUserRelation(params)
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            commit('SET_USER_RELATION', data)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取动态列表请求
    fetchDynamicList({ commit }, params) {
      return getDynamicList(params)
        .then(res => {
          const { code, data } = res
          if (+code === 0) {
            commit('SET_DYNAMIC_LIST', {
              list: data.list,
              isFrist: +params.pageNo === 1
            })
          }
          return res
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 获取问答、FM、文章、故事列表请求
    fetchBusinesses({ commit }, params) {
      return businesses(params)
        .then(res => {
          const { code, data } = res
          if (+code === 0) {
            data.map(item => {
              commit('SET_BUSINESSES_LIST', {
                list: item.list,
                isFrist: +params.page === 1,
                type: item.business?.type
              })
            })
          }
          return res
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 获取评价列表请求
    fetchRatelist({ commit, state }, params) {
      return getRateList(params)
        .then(res => {
          const { code, data } = res
          const { isRateTab } = state
          if (+code === 0) {
            console.log(typeof data.count, 'testtes')
            commit('SET_RATE_LIST', {
              list: data.list,
              isFrist: +params.page === 1,
              isFinished: data.count <= (params.size || 20),
              isRateTab: isRateTab ? isRateTab : !!data.list.length
            })
            commit('SET_RATE_COUNT', data.count)
          }
          return res
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 修改评价类型
    setCurrentRateType({ commit }, type) {
      commit('SET_CURRENT_RATE_TYPE', type)
    },
    fetchTalkVideo({ commit }, params) {
      return talkVideos(params)
        .then(res => {
          commit('SETTALKVIDEO', res.data)
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 获取倾听师信息
    fetchQingsuService({ commit }, params) {
      return getQingsuService(params)
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            commit('SET_QINGSU_SERVICE', data)
          }
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 获取倾听师评论
    fetchQingsuRate({ commit, state }, params) {
      return getQingsuRateList(params)
        .then(res => {
          const { code, data } = res
          const { isRateTab } = state
          if (+code === 0) {
            data.rate_list.forEach(item => {
              item.user_avatar = item.avatar
              item.user_name = item.is_guest ? '匿名用户' : item.nickname
              item.rate_time = item.created.replace(/\./g, '-')
            })
            commit('SET_QINGSU_RATE_INFO', {
              list: data.rate_list,
              isFrist: +params.page === 1,
              isFinish: data.rate_list.length < (params.size || 20),
              isRateTab: isRateTab ? isRateTab : !!data.rate_list.length
            })
          }
          return res
        })
        .catch(err => {
          console.log(err)
          return err
        })
    },
    // 获取是否倾诉新来访
    fetchQingsuVisit({ commit }, params) {
      return getQingsuNewVisit(params)
        .then(res => {
          const { code, data } = res
          if (code === 0) {
            commit('SET_QINGSU_VISIT', data)
          }
        })
        .catch(err => {
          console.log(err)
          return err
        })
    }
  }
}
export default {
  store,
  name: 'homepage'
}
